import React, { useContext } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { UIContext } from "../shared/layout"
import Slider from "react-slick"
import {
  SolutionCardWrapper,
  SolutionCardImg,
  SolutionCardTitle,
  SolutionCardText,
  SectionContainer,
  SectionTitle,
  SliderContainer,
} from "./problem-solving.style"
import Grid from "../shared/grid"

const SolutionCard = ({ logoSrc, title, text }) => {
  return (
    <SolutionCardWrapper>
      <SolutionCardImg src={logoSrc} />
      <SolutionCardTitle>{title}</SolutionCardTitle>
      <SolutionCardText>{text}</SolutionCardText>
    </SolutionCardWrapper>
  )
}

export default function ProblemSolvingSection() {
  const {
    state: { breakpoint, clientLoaded },
  } = useContext(UIContext)

  const query = useStaticQuery(graphql`
    query {
      customerExperience: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Solving Problems Icons/customer_experience.svg"
        }
      ) {
        publicURL
      }
      marketing: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Solving Problems Icons/marketing.svg"
        }
      ) {
        publicURL
      }
      people: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Solving Problems Icons/people.svg"
        }
      ) {
        publicURL
      }
      productDevelopment: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Solving Problems Icons/product development.svg"
        }
      ) {
        publicURL
      }
      sales: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Solving Problems Icons/sales.svg"
        }
      ) {
        publicURL
      }
    }
  `)

  return (
    <SectionContainer>
      <Grid>
        <SectionTitle>What problems do you want to solve?</SectionTitle>
        {clientLoaded && (
          <SliderContainer>
            <Slider arrows={breakpoint !== "sm"} dots>
              <SolutionCard
                logoSrc={query.productDevelopment.publicURL}
                title="Product & Development"
                text="We pride ourselves on solving tough problems. Indoor mapping at scale, across the largest class asset is no small feat. Our product and development teams are constantly finding ways to innovate and automate best-in-class indoor mapping tools and applications across all industries and geographies."
              />
              <SolutionCard
                logoSrc={query.marketing.publicURL}
                title="Marketing"
                text="Our marketing team is at the forefront of our go-to-market strategy. In a specialized industry with some big competitors, we're constantly looking for ways to highlight Mappedin's unique value proposition. We have a great story to tell and a strong product to back it up."
              />
              <SolutionCard
                logoSrc={query.sales.publicURL}
                title="Sales"
                text="Our sales team is constantly talking to property managers, operators, and disruptors about how indoor mapping can supplement their business. While Mappedin’s core value remains the same across all industries, there are many applications of our platform. The sales team is always staying ahead of the curve on how indoor mapping can solve different needs."
              />
              <SolutionCard
                logoSrc={query.customerExperience.publicURL}
                title="Customer Experience"
                text="Customer experience at Mappedin is all about implementation, support, and success. We are obsessed with giving our customers the best experience and ensuring their voice is heard. Whether small feature requests or large product evolutions, our customers' voice is a critical component to our business. "
              />
              <SolutionCard
                logoSrc={query.people.publicURL}
                title="People"
                text="Our people and culture team supports everyone at Mappedin, ensuring we’re all setup for success. From finding the best talent, to interviewing, hiring, and onboarding, this team is critical to our business. The people team helps us maintain a high performance culture to match the needs of our high performing customers."
              />
            </Slider>
          </SliderContainer>
        )}
      </Grid>
    </SectionContainer>
  )
}
